import {
    AfterViewInit,
    Component,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { CostCenter } from '../../contract-cumulative/CostCenter';
import { Users } from '../../contract-cumulative/store/users.model';
import { ChargeNumber, Contract } from '../../data-services';
import { DeferBilling } from '../../data-services/defer-billing';
import { RecalculateSetting } from '../../data-services/recalculate-transactions/recalculate-settings/recalculate-settings.model';
import * as fromLookups from '../../lookups';
import { CalcType, IServiceItem, ITask, IUserGroup } from '../../lookups';
import { PayrollItem } from '../../payroll/item';
import { IStatusMessage, Process, SelectItem, Table } from '../../shared';
import { columnResize } from '../../shared/columnResize';
import { DisplayErrors } from '../../shared/errors-sidenav';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { IUserInfo } from '../../user-info';

@Component({
    selector: 'ef-defer-billing-presenter',
    templateUrl: './defer-billing-presenter.component.html',
    styleUrls: ['./defer-billing-presenter.component.scss'],
    standalone: false
})
export class DeferBillingPresenterComponent
    extends DisplayErrors<DeferBilling>
    implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
    SelectedErrorSubject = new ReplaySubject<IStatusMessage>(1);
    startDate: any;
    endDate: any;
    companyFYNotice: any[];

    elements: HTMLCollection;

    private BillingSubject = new ReplaySubject<Array<DeferBilling>>(1);
    private _billing: Array<any>;
    filteredBilling: DeferBilling[];

    @Input() set billing(value: Array<DeferBilling>) {
        // this.log.verbose(this.IsLoading);
        if (value != null) {
            this._billing = value.map(x => ({
                Txnid: x.Txnid,
                Sessionid: x.Sessionid,
                Billdate: x.Billdate,
                Billablestatus: x.Billablestatus,
                Txntype: x.Txntype,
                //TxnTypeName: this.findTxnType(x.Txntype),
                Txndate: x.Txndate,
                Modifieddate: x.Modifieddate,
                Modifiedby: x.Modifiedby,
                Createdate: x.Createdate,
                Adjustmentstatus: x.Adjustmentstatus,
                // Contractlistid: x.Contractlistid,
                Contractdesc: x.Contractdesc,
                Tasklistid: x.Tasklistid,
                Task: x.Task,
                Employeelistid: x.Employeelistid,
                Person: x.Person,
                Pilistid: x.Pilistid,
                PayrollItem: x.PayrollItem,
                Silistid: x.Silistid,
                ServiceItem: x.ServiceItem,
                Costcenterid: x.Costcenterid,
                CostCenter: x.CostCenter,
                Hoursworked: x.Hoursworked,
                Invoiceamount: x.Invoiceamount,
                Invoiceburdened: x.Invoiceburdened,
                Gacost: x.Gacost,
                Mhcost: x.Mhcost,
                Ohcost: x.Ohcost,
                Frcost: x.Frcost,
                Feecost: x.Feecost,
                Invoiceenddate: x.Invoiceenddate,
                Invoicenbr: x.Invoicenbr,
                TxnNotes: x.TxnNotes,
                Deferred: x.Deferred,
                Status: x.Status,
                id: x.id,
                original: x.original,
                Row_Version: x.Row_Version
            }));
            this.filteredBilling = this._billing;
            this.BillingSubject.next(this._billing);

            this.txnTypesFilterSelectItem = value.map(x => ({
                value: this.findTxnType(x.Txntype),
                label: this.findTxnType(x.Txntype)
            }));
            this.txnTypesFilterSelectItem =
                this.txnTypesFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );

            this.userGroupsFilterSelectItem = value.map(x => ({
                value: x.Costcenterid,
                label: this.findCostCenterName(x.Costcenterid)
            }));
            this.userGroupsFilterSelectItem =
                this.userGroupsFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );

            this.tasksFilterSelectItem = value.map(x => ({
                value: x.Tasklistid,
                label: this.findTask(x)
            }));
            this.tasksFilterSelectItem = this.tasksFilterSelectItem.filter(
                (v, i, a) => a.findIndex(t => t.label === v.label) === i
            );

            this.contractsFilterSelectItem = value.map(x => ({
                value: x.Contractlistid,
                label: x.Contractdesc
            }));
            this.contractsFilterSelectItem =
                this.contractsFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );

            this.directReportsFilterSelectItem = value.map(x => ({
                value: x.Employeelistid,
                label: this.findEmployee(x)
            }));
            this.directReportsFilterSelectItem =
                this.directReportsFilterSelectItem.filter(x => x.value != null);
            this.directReportsFilterSelectItem =
                this.directReportsFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );

            this.serviceItemsFilterSelectItem = value.map(x => ({
                value: x.Silistid,
                label: this.findServiceItem(x)
            }));
            this.serviceItemsFilterSelectItem =
                this.serviceItemsFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );

            this.payrollItemsFilterSelectItem = value.map(x => ({
                value: x.Pilistid,
                label: this.findPayrollItem(x)
            }));
            this.payrollItemsFilterSelectItem =
                this.payrollItemsFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );
        }
        // this.IsLoading = false;
    }
    get billing(): Array<DeferBilling> {
        return this._billing;
    }

    private TasksSubject = new ReplaySubject<Array<ITask>>(1);
    private _tasks: Array<ITask>;
    @Input() set tasks(value: Array<ITask>) {
        if (value) {
            this._tasks = value;
            const filteredTasks = this._tasks.filter(
                x => x.ContractType != 'LOC'
            );
            this.TasksSubject.next(value);
            this.tasksSelectItem = filteredTasks.map(x => ({
                value: x.TaskListID,
                label: x.TaskLongName
            }));
            this.tasksInTableSelectItem = filteredTasks.map(x => ({
                value: x.TaskListID,
                label: x.TaskLongName
            }));
        }
    }
    get tasks(): Array<ITask> {
        return this._tasks;
    }

    private DirectReportsSubject = new ReplaySubject<Array<Partial<Users>>>(1);
    private _directreports: Array<Partial<Users>>;
    @Input() set directreports(value: Array<Partial<Users>>) {
        if (value) {
            value.splice(0, 0, {
                EmployeeListID: 'SYS000000000000000000000000000000000',
                EmployeeName: 'Not applicable'
            });
            this._directreports = value;
            this.DirectReportsSubject.next(value);
            this.directReportsSelectItem = this._directreports.map(x => ({
                value: x.EmployeeListID,
                label: x.EmployeeName
            }));
        }
    }
    get directreports(): Array<Partial<Users>> {
        return this._directreports;
    }

    private ServiceItemsSubject = new ReplaySubject<Array<IServiceItem>>(1);
    private _serviceitems: Array<IServiceItem>;
    @Input() set serviceitems(value: Array<IServiceItem>) {
        if (value) {
            this._serviceitems = value;
            this.ServiceItemsSubject.next(value);
            this.serviceItemsSelectItem = this._serviceitems.map(x => ({
                value: x.SIListID,
                label: x.ServiceItem
            }));
            this.log.verbose('si count = ' + this._serviceitems.length);
        }
    }
    get serviceitems(): Array<IServiceItem> {
        return this._serviceitems;
    }

    private PayrollItemsSubject = new ReplaySubject<Array<PayrollItem>>(1);
    private _payrollitems: Array<PayrollItem>;
    @Input() set payrollitems(value: Array<PayrollItem>) {
        if (value) {
            this._payrollitems = value;
            this.PayrollItemsSubject.next(value);
            this.payrollItemsSelectItem = this._payrollitems.map(x => ({
                value: x.PIListID,
                label: x.PayrollItem
            }));
            this.log.verbose('pi count = ' + this._payrollitems.length);
        }
    }
    get payrollitems(): Array<PayrollItem> {
        return this._payrollitems;
    }

    // private SEItemsSubject = new ReplaySubject<Array<any>>(1);
    // private _seitems: Array<any>;
    // @Input() set seitems(value: Array<any>) {
    //     if (value) {
    //         this._seitems = value;
    //         this.SEItemsSubject.next(this._seitems);
    //         // this.serviceItemsSelectItem = this._seitems.map(x => ({
    //         //     value: x.IListID,
    //         //     label: x.Item
    //         // }));
    //         this.log.verbose('i count = ' + this._seitems.length);
    //     }
    // }
    // get seitems(): Array<any> {
    //     return this._seitems;
    // }

    private ContractsSubject = new ReplaySubject<Array<Contract.Contract>>(1);
    private _contracts: Array<Contract.Contract>;
    @Input() set contracts(value: Array<Contract.Contract>) {
        if (value) {
            this._contracts = value;
            const filteredContracts = this._contracts.filter(
                x => x.ContractType != 'LOC' && x.IsActive == true
            );
            this.ContractsSubject.next(value);
            this.contractsSelectItem = filteredContracts.map(x => ({
                value: x.ContractListID,
                label: x.ContractDesc
            }));
        }
    }
    get contracts(): Array<Contract.Contract> {
        return this._contracts;
    }

    // filteredChargeNumbers: Array<ChargeNumber.ChargeNumber>;
    private ChargeNumbersSubject = new ReplaySubject<
        Array<ChargeNumber.ChargeNumber>
    >(1);
    private _chargenumbers: Array<ChargeNumber.ChargeNumber>;
    @Input() set chargenumbers(value: Array<ChargeNumber.ChargeNumber>) {
        if (value) {
            this._chargenumbers = value;
            // this.filteredChargeNumbers = value;
            this.ChargeNumbersSubject.next(value);
            this.chargeNumbersSelectItem = value.map(x => ({
                value: x.CNListID,
                label: x.FullName
            }));
        }
    }
    get chargenumbers(): Array<ChargeNumber.ChargeNumber> {
        return this._chargenumbers;
    }

    private TxnTypesSubject = new ReplaySubject<Array<CalcType>>(1);
    private _txntypes: Array<CalcType>;
    @Input() set txntypes(value: Array<CalcType>) {
        if (value) {
            this._txntypes = value;
            const filteredTxnTypes = this._txntypes.filter(
                x => x.CostType == this.doi
            );
            this.TxnTypesSubject.next(value);
            this.txnTypesSelectItem = filteredTxnTypes.map(x => ({
                value: x.CalcType,
                label: x.CalcDesc
            }));
            this.txnTypesInTableSelectItem = filteredTxnTypes.map(x => ({
                value: x.CalcType,
                label: x.CalcDesc
            }));
        }
    }
    get txntypes(): Array<CalcType> {
        return this._txntypes;
    }

    // TODO: is this used?  if not remove it
    private _companysettings: Array<RecalculateSetting>;
    @Input() set companysettings(value: Array<RecalculateSetting>) {
        if (value) {
            this._companysettings = value;
            const fyyear = moment(this._companysettings[0].SettingValue).year();
            this.CSFYStart = moment(
                this._companysettings[0].SettingValue
            ).toDate();
            this.CSFYEnd = moment(`12/31/${fyyear}`).toDate();
            this.companyFYNotice = [
                {
                    severity: 'info',
                    summary: '',
                    detail: `Company Fiscal Year set to ${moment(
                        this.CSFYStart
                    ).format('MM/DD/YYYY')} - ${moment(this.CSFYEnd).format(
                        'MM/DD/YYYY'
                    )}`
                }
            ];
        }
    }
    get companysettings(): Array<RecalculateSetting> {
        return this._companysettings;
    }

    @Input() public userGroups: Array<fromLookups.IUserGroup>;

    @Input() public process: Process;

    @Input() public userInfo: IUserInfo;

    @Output() SaveBilling = new ReplaySubject<DeferBilling>(1);
    @Output() LoadBilling = new ReplaySubject<any>(1);
    @Output() DeleteBilling = new ReplaySubject<DeferBilling>(1);
    @Output() LoadChargeNumbers = new ReplaySubject<any>(1);
    public editing?: DeferBilling = {} as DeferBilling;
    clonedBilling: { [i: string]: DeferBilling } = {};
    active = true;
    public moment: any;
    tableScrollHeight = '50em';
    ccFormGroup: UntypedFormGroup;
    taskFormGroup: UntypedFormGroup;
    siFormGroup: UntypedFormGroup;
    piFormGroup: UntypedFormGroup;
    contractFormGroup: UntypedFormGroup;
    empFormGroup: UntypedFormGroup;
    filterFormGroup: UntypedFormGroup;
    typeFormGroup: UntypedFormGroup;
    doi = 'Direct';
    txnTypesSelectItem: SelectItem[] = [];
    txnTypesInTableSelectItem: SelectItem[] = [];
    userGroupsSelectItem: SelectItem[] = [];
    userGroupsInTableSelectItem: SelectItem[] = [];
    tasksSelectItem: SelectItem[] = [];
    tasksInTableSelectItem: SelectItem[] = [];
    contractsSelectItem: SelectItem[] = [];
    chargeNumbersSelectItem: SelectItem[] = [];
    directReportsSelectItem: SelectItem[] = [];
    directReportsInTableSelectItem: SelectItem[] = [];
    serviceItemsSelectItem: SelectItem[] = [];
    payrollItemsSelectItem: SelectItem[] = [];
    sessionDatesSelectItem: SelectItem[] = [];

    txnTypesFilterSelectItem: SelectItem[] = [];
    userGroupsFilterSelectItem: SelectItem[] = [];
    tasksFilterSelectItem: SelectItem[] = [];
    contractsFilterSelectItem: SelectItem[] = [];
    directReportsFilterSelectItem: SelectItem[] = [];
    serviceItemsFilterSelectItem: SelectItem[] = [];
    payrollItemsFilterSelectItem: SelectItem[] = [];

    siHidden = false;
    siColumnHidden = false;
    empHidden = false;
    empColumnHidden = false;
    selectedDirectReports: Users[] = [];
    selectedServiceItems: any[] = [];
    selectedPayrollItems: PayrollItem[] = [];
    selectedcontracts: Contract.Contract[] = [];
    selectedChargeNumbers: ChargeNumber.ChargeNumber[] = [];
    selectedTasks: ITask[] = [];
    selectedCCs: IUserGroup[] = [];
    costCenters: CostCenter[] = [];

    @Input() public IsLoading: boolean;

    IsBurdenHidden = true;
    IsIndirectFilter = false;

    selectedContract: Contract.Contract;

    asOfDateValid = false;
    contractValid = false;
    directReportValid = false;
    serviceItemValid = false;
    txnTypeValid = false;
    taskValid = false;
    ccValid = false;

    asOfDateIsRequired = false;
    contractIsRequired = false;
    directReportIsRequired = false;
    serviceItemIsRequired = false;
    txnTypeIsRequired = false;
    taskIsRequired = false;
    ccIsRequired = false;

    currentPayPeriodStart: any;
    currentPayPeriodEnd: any;
    prevPayPeriodStart: any;
    prevPayPeriodEnd: any;

    SIColumnHidden = false;
    PIColumnHidden = false;
    EmpColumnHidden = false;
    BillableColumnHidden = false;
    CCColumnHidden = false;

    length: number;
    header: string;

    @ViewChild(Table, { static: true })
    dbTable: Table;

    colsCanBeHidden: any[];
    cols: any[];
    CSFYStart: Date;
    CSFYEnd: Date;

    billDateForMultiUpdate: Date;
    noteForMultiUpdate: string;

    dbTableSelection: DeferBilling[] = [];

    IsMultiUpdate = false;

    ccColumnVisible = true;

    deferredOnly = false;
    
    IsColumnFrozen = false;

    _selectedColumns: any[];
    @Input() get selectedColumns(): any[] {
        return this._selectedColumns;
    }

    set selectedColumns(val: any[]) {
        // restore original order
        this._selectedColumns = this.colsCanBeHidden.filter(col =>
            val.includes(col)
        );
    }

    minDate: Date;
    billDate: Date;

    updateBtnLabel = 'Update';

    public currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });

    constructor(@Inject(LoggingService) private log: LoggingService) {
        super();
        this.moment = moment;

        this.filterFormGroup = new UntypedFormGroup({
            Range: new UntypedFormControl(null),
            Contracts: new UntypedFormControl(null),
            SI: new UntypedFormControl(null),
            CN: new UntypedFormControl(null)
        });

        this.ccFormGroup = new UntypedFormGroup({
            CC: new UntypedFormControl(null)
        });

        this.taskFormGroup = new UntypedFormGroup({
            Task: new UntypedFormControl(null)
        });

        this.siFormGroup = new UntypedFormGroup({
            SI: new UntypedFormControl(null)
        });

        this.empFormGroup = new UntypedFormGroup({
            Emp: new UntypedFormControl(null)
        });

        this.typeFormGroup = new UntypedFormGroup({
            Type: new UntypedFormControl(null)
        });

        this.piFormGroup = new UntypedFormGroup({
            pi: new UntypedFormControl(null)
        });

        this.contractFormGroup = new UntypedFormGroup({
            Contracts: new UntypedFormControl(null)
        });
    }

    ngOnInit() {
        this.cols = [
            { field: 'Adjustmentstatus', header: 'Status' },
            { field: 'Txndate', header: 'Txn Date' },
            { field: 'Txntype', header: 'Txn Type' },
            { field: 'Task', header: 'Task' },
            { field: 'Person', header: 'Person' },
            { field: 'ServiceItem', header: 'Item' },
            { field: 'PayrollItem', header: 'Payroll Item' },
            { field: 'CostCenter', header: 'Cost Center' },
            { field: 'Billablestatus', header: 'Billable Status' },
            { field: 'Hoursworked', header: 'Hours' },
            { field: 'Invoiceamount', header: 'Invoiced Amount' },
            { field: 'Gacost', header: 'G&A Invoiced' },
            { field: 'Mhcost', header: 'MH Invoiced' },
            { field: 'Ohcost', header: 'OH Invoiced' },
            { field: 'Frcost', header: 'FR Invoiced' },
            { field: 'Feecost', header: 'Fee Invoiced' },
            { field: 'Actualamount', header: 'Incurred Amount' },
            { field: 'Gacostebr', header: 'G&A Incurred' },
            { field: 'Mhcostebr', header: 'MH Incurred' },
            { field: 'Ohcostebr', header: 'OH Incurred' },
            { field: 'Frcostebr', header: 'FR Incurred' },
            { field: 'Feecostebr', header: 'Fee Incurred' }
        ];

        this.colsCanBeHidden = [
            { field: 'Person', header: 'Person' },
            { field: 'ServiceItem', header: 'Item' },
            { field: 'PayrollItem', header: 'Payroll Item' },
            { field: 'CostCenter', header: 'Cost Center' }
            // { field: 'Billablestatus', header: 'Billable Status' },
        ];

        this._selectedColumns = this.colsCanBeHidden;

        this.setupObservables();
        this.setupSubscriptions();

        setTimeout(() => {
            this.elements = document.getElementsByClassName('p-header-cell');
        }, 0);
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (changes.userInfo && changes.userInfo.currentValue) {
            // set of property is done before ngOnChanges
            this.startDate = this.userInfo.PrevPayPeriodStart;
            this.endDate = this.userInfo.PrevPayPeriodEnd;
            this.currentPayPeriodStart = this.userInfo.CurrentPayPeriodStart;
            this.currentPayPeriodEnd = this.userInfo.CurrentPayPeriodEnd;
            this.prevPayPeriodStart = this.userInfo.PrevPayPeriodStart;
            this.prevPayPeriodEnd = this.userInfo.PrevPayPeriodEnd;
            this.filterFormGroup.controls['Range'].patchValue([
                this.prevPayPeriodStart,
                this.prevPayPeriodEnd
            ]);
        }
        if (
            changes.userGroups &&
            changes.userGroups.currentValue &&
            changes.userGroups.currentValue.length > 0
        ) {
            // set of property is done before ngOnChanges, no need for this
            // this.userGroups = changes.userGroups.currentValue;
            this.userGroups = this.userGroups.filter(x =>
                x.PrefixedGroupID.includes('C')
            );
            this.userGroupsSelectItem = this.userGroups.map(x => ({
                label: x.GroupName,
                value: x.GroupID
            }));
            this.userGroupsInTableSelectItem = this.userGroups.map(x => ({
                label: x.GroupName,
                value: x.GroupID
            }));
            if (this.userGroups.length == 1) {
                this.ccColumnVisible = false;
            }
        }
    }
    ngAfterViewInit() {
        this.IsColumnFrozen = true;
    }
    ngOnDestroy() {
        this.dbTable.clear();
        this.active = false;
    }

    onColumnResize($event) {
        var table = document.querySelector('table');
        columnResize($event, 7, table);
    }

    setupObservables() {
        this.log.verbose({
            type: 'DeferBillingPresenterComponent:setupObservables'
        });
    }

    deferredOnlyToggle($event) {
        if ($event.checked == true) {
            this.filteredBilling = this.billing.filter(
                x => x.Deferred == $event.checked
            );
        } else {
            this.filteredBilling = this.billing;
        }
    }

    setupSubscriptions() {
        this.log.verbose({
            type: 'DeferBillingPresenterComponent:setupSubscriptions'
        });

        this.filterFormGroup.controls['Range'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    if (value[0] && value[1]) {
                        this.startDate = value[0];
                        this.endDate = value[1];
                        // if (this.selectedServiceItems.length > 0 && this.selectedChargeNumbers.length > 0
                        //     && this.selectedcontracts.length > 0 && moment(this.startDate).isValid() && moment(this.endDate).isValid()) {
                        //     // this.IsLoading = true;
                        //     const POSTData: any = {
                        //         Contracts: this.selectedcontracts,
                        //         ChargeNumbers: this.selectedChargeNumbers,
                        //         ServiceItems: this.selectedServiceItems,
                        //         StartDate: moment(value[0]).format('MM/DD/YYYY'),
                        //         EndDate: moment(value[1]).format('MM/DD/YYYY')
                        //     };
                        //     this.LoadBilling.next(POSTData);
                        // }
                    }
                }
            });
        this.filterFormGroup.controls['Contracts'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    if (value) {
                        this.selectedChargeNumbers = [];
                        this.filterFormGroup.controls['CN'].reset();
                        this.selectedcontracts = [];
                        // value.forEach(val => {
                        //     this.selectedcontracts.push(
                        //         this.contracts.find(
                        //             x => x.ContractListID == val
                        //         ) as Contract.Contract
                        //     );
                        // });
                        this.selectedcontracts.push(this.contracts.find(x => x.ContractListID == value));
                        if (this.selectedcontracts.length > 0) {
                            const CNPOSTData = {
                                ContractList: this.selectedcontracts,
                                Activeonly: true
                            };
                            this.LoadChargeNumbers.next(CNPOSTData);
                        }
                    }
                }
            });

        this.filterFormGroup.controls['CN'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    if (value) {
                        const chargenumberids = [];
                        this.selectedChargeNumbers = [];
                        value.forEach(val => {
                            this.selectedChargeNumbers.push(
                                this.chargenumbers.find(
                                    x => x.CNListID == val
                                ) as ChargeNumber.ChargeNumber
                            );
                            // chargenumberids.push(
                            //     this.chargenumbers.find(x => x.CNListID == val)
                            //         .FullName
                            // );
                        });
                        // this.dbTable.filter(chargenumberids, 'CNListID', 'in');
                        // if (this.selectedServiceItems.length > 0 && this.selectedChargeNumbers.length > 0
                        //     && this.selectedcontracts.length > 0 && moment(this.startDate).isValid() && moment(this.endDate).isValid()) {
                        //     // this.IsLoading = true;
                        //     const POSTData: any = {
                        //         Contracts: this.selectedcontracts,
                        //         ChargeNumbers: this.selectedChargeNumbers,
                        //         ServiceItems: this.selectedServiceItems,
                        //         StartDate: moment(this.startDate).format(
                        //             'MM/DD/YYYY'
                        //         ),
                        //         EndDate: moment(this.endDate).format('MM/DD/YYYY')
                        //     };
                        //     this.LoadBilling.next(POSTData);
                        // } else {
                        //     this.billing = [];
                        //     this.BillingSubject.next(this.billing);
                        // }
                    }
                }
            });

        this.filterFormGroup.controls['SI'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                const siids = [];
                this.selectedServiceItems = [];
                if (value != null) {
                    if (value) {
                        value.forEach(val => {
                            this.selectedServiceItems.push(
                                this.serviceitems.find(
                                    x => x.SIListID == val
                                ) as fromLookups.IServiceItem
                            );
                            // siids.push(
                            //     this.serviceitems.find(x => x.SIListID == val)
                            //         .ServiceItem
                            // );

                            // if (this.selectedServiceItems.length > 0) {
                            //     this.selectedServiceItems.forEach(item => {
                            //         if (item == null) {
                            //             let index = this.selectedServiceItems.findIndex(x => x == item);
                            //             let alteredItem = this.seitems.find(x => x.IListID == val);
                            //             alteredItem = alteredItem = {
                            //                 SIListID: alteredItem.IListID,
                            //                 ServiceItem: alteredItem.Item,
                            //                 IsActive: alteredItem.IsActive,
                            //                 DisplaySI: null,
                            //                 DisplaySIRate: null,
                            //                 ExpenseType: null,
                            //                 Postingtype: null,
                            //                 ServiceItemCost: null,
                            //                 ServiceItemDesc: null,
                            //                 ServiceItemPrice: null,
                            //                 ServiceItemType: null
                            //             };
                            //             item = alteredItem;
                            //             this.selectedServiceItems.splice(index, 1, item);
                            //         }
                            //     });
                            // }
                        });
                        this.log.verbose(this.selectedServiceItems);
                        // this.dbTable.filter(siids, 'SIListID', 'in');
                        // if (this.selectedServiceItems.length > 0 && this.selectedChargeNumbers.length > 0
                        //     && this.selectedcontracts.length > 0 && moment(this.startDate).isValid() && moment(this.endDate).isValid()) {
                        //     // this.IsLoading = true;
                        //     const POSTData: any = {
                        //         Contracts: this.selectedcontracts,
                        //         ChargeNumbers: this.selectedChargeNumbers,
                        //         ServiceItems: this.selectedServiceItems,
                        //         StartDate: moment(this.startDate).format(
                        //             'MM/DD/YYYY'
                        //         ),
                        //         EndDate: moment(this.endDate).format('MM/DD/YYYY')
                        //     };
                        //     this.LoadBilling.next(POSTData);
                        // } else {
                        //     this.billing = [];
                        //     this.BillingSubject.next(this.billing);
                        // }
                    }
                }
            });
    }

    findCostCenterName(Costcenterid: number): string | undefined {
        if (Costcenterid != null) {
            if (this.userGroups && this.userGroups.length > 0) {
                if (Costcenterid === 0) {
                    return '';
                } else {
                    const cc = this.userGroups.find(
                        x => x.GroupID === Costcenterid
                    );
                    return cc?.GroupName;
                }
            }
        } else {
            return '';
        }
    }

    findTask(rowData: DeferBilling): string | undefined {
        if (rowData.Tasklistid != null) {
            if (this.tasks && this.tasks.length > 0) {
                const index = this.tasks.findIndex(
                    x => x.TaskListID === rowData.Tasklistid
                );
                if (index !== -1) {
                    const task = this.tasks[index];
                    return task.TaskLongName;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }

    findEmployee(rowData: DeferBilling): string | undefined {
        if (rowData.Employeelistid != null) {
            if (this.directreports && this.directreports.length > 0) {
                const index = this.directreports.findIndex(
                    x => x.EmployeeListID === rowData.Employeelistid
                );
                if (index !== -1) {
                    const directreport = this.directreports[index];
                    return directreport.EmployeeName;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }

    findServiceItem(rowData: DeferBilling): string | undefined {
        if (rowData.Silistid != null) {
            if (this.serviceitems && this.serviceitems.length > 0) {
                const index = this.serviceitems.findIndex(
                    x => x.SIListID === rowData.Silistid
                );
                if (index !== -1) {
                    const serviceitem = this.serviceitems[index];
                    return serviceitem.ServiceItem;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }

    findPayrollItem(rowData: DeferBilling): string | undefined {
        if (rowData.Pilistid != null) {
            if (this.payrollitems && this.payrollitems.length > 0) {
                const index = this.payrollitems.findIndex(
                    x => x.PIListID === rowData.Pilistid
                );
                if (index !== -1) {
                    const payrollitem = this.payrollitems[index];
                    return payrollitem.PayrollItem;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }

    findTxnType(rowData: any): string | undefined {
        if (rowData != null) {
            if (this.txntypes && this.txntypes.length > 0) {
                const index = this.txntypes.findIndex(
                    x => x.CalcType === rowData
                );
                if (index !== -1) {
                    const txntype = this.txntypes[index];
                    return txntype.CalcDesc;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }

    filterTable($event, filterType) {
        // use this for all table filters
        if (filterType == 'si') {
            this.dbTable.filter($event.value, 'ServiceItem', 'in');
        } else if (filterType == 'pi') {
            this.dbTable.filter($event.value, 'PayrollItem', 'in');
        } else if (filterType == 'task') {
            this.dbTable.filter($event.value, 'Task', 'in');
        } else if (filterType == 'type') {
            this.dbTable.filter($event.value, 'Txntype', 'in');
        } else if (filterType == 'employee') {
            this.dbTable.filter($event.value, 'Person', 'in');
        } else if (filterType == 'cc') {
            this.dbTable.filter($event.value, 'CostCenter', 'in');
        } else if (filterType == 'contract') {
            this.dbTable.filter($event.value, 'Contractdesc', 'in');
        }
    }

    onRowSelect($event) {
        if (this.dbTableSelection.length > 0) {
            this.IsMultiUpdate = true;
            this.updateBtnLabel = `Update ${this.dbTableSelection.length} row(s)`;
        } else {
            this.IsMultiUpdate = false;
            this.updateBtnLabel = `Update`;
        }
    }

    onRowUnselect($event) {
        if (this.dbTableSelection.length > 0) {
            this.IsMultiUpdate = true;
            this.updateBtnLabel = `Update ${this.dbTableSelection.length} row(s)`;
        } else {
            this.IsMultiUpdate = false;
            this.updateBtnLabel = `Update`;
        }
    }

    onHeaderCheckboxToggle($event) {
        if (this.dbTableSelection.length > 0) {
            this.IsMultiUpdate = true;
            this.updateBtnLabel = `Update ${this.dbTableSelection.length} row(s)`;
        } else {
            this.IsMultiUpdate = false;
            this.updateBtnLabel = `Update`;
        }
    }

    multiUpdate() {
        if (this.dbTableSelection.length > 0) {
            this.dbTableSelection.forEach(ele => {
                if (this.billDateForMultiUpdate != null) {
                    ele.Billdate = this.billDateForMultiUpdate;
                }
                if (this.noteForMultiUpdate != null) {
                    ele.TxnNotes = this.noteForMultiUpdate;
                }
                this.SaveBilling.next(ele);
            });
        }
        this.noteForMultiUpdate = '';
        this.dbTableSelection = [];
    }

    onEditInit($event: { data: DeferBilling }) {
        this.editing = { ...$event.data };
    }

    onRowEditInit(rowData: DeferBilling) {
        this.clonedBilling[rowData.Txnid] = { ...rowData };
        this.editing = rowData;
        this.log.verbose('onRowEditInit');
        this.minDate = new Date(rowData.Txndate);
        if (moment(rowData.Billdate).isValid() == false) {
            this.billDate = new Date();
        } else {
            this.billDate = rowData.Billdate;
        }
    }

    onRowEditSave(rowData: DeferBilling) {
        this.log.verbose(this.billDate);
        rowData = {
            ...rowData,
            Billdate: this.billDate
        };
        this.SaveBilling.next(rowData);
        delete this.clonedBilling[rowData.Txnid];
        delete this.editing;
        this.log.verbose('onRowEditSave');
    }

    onRowEditCancel(item: DeferBilling) {
        delete this.clonedBilling[item.Txnid];
        delete this.editing;
        this.log.verbose('onRowEditCancel');
    }

    onDBDelete(db) {
        this.DeleteBilling.next(db);
    }

    burdensVisibility() {
        this.IsBurdenHidden = !this.IsBurdenHidden;
    }

    onSelectedColumnsChange($event) {
        if ($event.value) {
            if ($event.itemValue) {
                if ($event.itemValue.header) {
                    if ($event.itemValue.header == 'Item') {
                        if (this.SIColumnHidden == true) {
                            this.SIColumnHidden = false;
                        } else {
                            this.SIColumnHidden = true;
                        }
                    }
                    if ($event.itemValue.header == 'Person') {
                        if (this.EmpColumnHidden == true) {
                            this.EmpColumnHidden = false;
                        } else {
                            this.EmpColumnHidden = true;
                        }
                    }
                    if ($event.itemValue.header == 'Payroll Item') {
                        if (this.PIColumnHidden == true) {
                            this.PIColumnHidden = false;
                        } else {
                            this.PIColumnHidden = true;
                        }
                    }
                    if ($event.itemValue.header == 'Cost Center') {
                        if (this.CCColumnHidden == true) {
                            this.CCColumnHidden = false;
                        } else {
                            this.CCColumnHidden = true;
                        }
                    }
                    if ($event.itemValue.header == 'Billable Status') {
                        if (this.BillableColumnHidden == true) {
                            this.BillableColumnHidden = false;
                        } else {
                            this.BillableColumnHidden = true;
                        }
                    }
                    this.header = $event.itemValue.header;
                }
                this.length = $event.value.length;
            } else {
                this.length = $event.value.length;
                if (this.length > 0) {
                    this.EmpColumnHidden = false;
                    this.SIColumnHidden = false;
                    this.PIColumnHidden = false;
                    this.CCColumnHidden = false;
                    this.BillableColumnHidden = false;
                } else {
                    if (this.EmpColumnHidden == true) {
                        this.EmpColumnHidden = false;
                    } else {
                        this.EmpColumnHidden = true;
                    }
                    if (this.SIColumnHidden == true) {
                        this.SIColumnHidden = false;
                    } else {
                        this.SIColumnHidden = true;
                    }
                    if (this.PIColumnHidden == true) {
                        this.PIColumnHidden = false;
                    } else {
                        this.PIColumnHidden = true;
                    }
                    if (this.CCColumnHidden == true) {
                        this.CCColumnHidden = false;
                    } else {
                        this.CCColumnHidden = true;
                    }
                    if (this.BillableColumnHidden == true) {
                        this.BillableColumnHidden = false;
                    } else {
                        this.BillableColumnHidden = true;
                    }
                    this.length = 0;
                }
            }
        }
    }

    applyCriteria() {
        if (
            // this.selectedcontracts.length > 0 &&
            moment(this.startDate).isValid() &&
            moment(this.startDate).isValid()
        ) {
            const POSTData: any = {
                Contracts: this.selectedcontracts,
                ChargeNumbers: this.selectedChargeNumbers,
                ServiceItems: this.selectedServiceItems,
                StartDate: moment(this.startDate).format('MM/DD/YYYY'),
                EndDate: moment(this.endDate).format('MM/DD/YYYY')
                // Deferredonly: this.deferredOnly
            };
            this.LoadBilling.next(POSTData);
        }
    }

    clearCriteria() {
        this.filterFormGroup.controls['Contracts'].reset();
        this.filterFormGroup.controls['CN'].reset();
        this.filterFormGroup.controls['SI'].reset();
        this.filterFormGroup.controls['Range'].reset();
        this.filterFormGroup.controls['deferredonly'].reset();
    }
}

export interface Item {
    IListID: string;
    Item: string;
    IsActive: boolean;
}
